import { Injectable } from '@angular/core';
import { Provider } from '../provider';
import { IWidget } from 'src/app/models/widget.model';

@Injectable()
export class EventWidgetService extends Provider<IWidget>{
  protected url = "events/widgets";
}
